// extracted by mini-css-extract-plugin
module.exports = {"display1":"Home_display1__3yz16","display":"Home_display__2PUR4"};